// Version : 0.0.1
// Author : AGALYA
// LastEdit : KARTHEESWARAN
// LASR ADD : PAYLOAD VALUES ARE ASSIGNED TO CONST
// MODFIED DATE:08-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import FunderActionTypes from './funder.types';
import {
	funderDetailsAdd,
	funderDetailsUpdate,
	funderListGet,
	funderDetailsFetch,
	funderDetailsDelete,
	FunderPublishUpdate,
} from './funder.service';
import {
	addFunderSuccess,
	addFunderFailure,
	addFunderResponseChanged,
	updateFunderSuccess,
	updateFunderFailure,
	updateFunderResponseChanged,
	getFunderListSuccess,
	getFunderListFailure,
	getFunderListResponseChanged,
	fetchFunderSuccess,
	fetchFunderFailure,
	fetchFunderResponseChanged,
	deleteFunderSuccess,
	deleteFunderFailure,
	deleteFunderResponseChanged,
	updateIsPublishFunderSuccess,
	updateIsPublishFunderFailure,
	updateIsPublishFunderResponseChanged,
} from './funder.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START ADD FUNDER DETAILS  ******************** */
export function* addFunderDetails({ payload }: any) {
	try {
		const {
			funderName,
			userPhoneNumber,
			branchID,
			userPassword,
			userEmailID,
			funderAddress,
			userPhoto,
			companyID,
			generalCompanyID,
			funderUniqueID,
			userID,
			databaseName,
			userName,
			userAccessBranchID,
			branchArr,
		} = payload;
		const key = 'AddFunderDetailsKey';
		const investorDetailJson = JSON.stringify(payload.investorDetailArr).replace(/"/g, "'");
		const accountDetailsJson = JSON.stringify(payload.accountDetailsArr).replace(/"/g, "'");
		const jsonData = {
			UserName: funderName,
			UserPhoneNumber: userPhoneNumber,
			BranchID: branchID,
			UserEmailID: userEmailID,
			UserPassword: userPassword,
			UserAddress: funderAddress,
			UserPhoto: userPhoto,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			InvestorDetails: investorDetailJson,
			UniqueID: funderUniqueID,
			CreatedBy: userID,
			AccountArr: accountDetailsJson,
			DatabaseName: databaseName,
			UserAccessName: userName,
			UserAccessBranchID: userAccessBranchID,
			AreaArr: branchArr,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(funderDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addFunderFailure(responseData.data));
		} else {
			yield put(addFunderSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addFunderFailure(error));
	}
}

/** *********************  RESET ADD FUNDER RESPONSE  ******************** */
export function* resetAddFunderResponse() {
	yield put(addFunderResponseChanged());
}

/** *********************  ON ADD FUNDER DETAILS  ******************** */
export function* onAddFunderDetails() {
	yield takeLatest(FunderActionTypes.ADD_FUNDER_START, addFunderDetails);
}

/** *********************  ON ADD FUNDER DETAILS RESPONSE RESET  ******************** */
export function* onAddFunderDetailsResponseReset() {
	yield takeLatest(FunderActionTypes.ADD_FUNDER_RESPONSE_RESET, resetAddFunderResponse);
}
/** *********************  END ADD FUNDER DETAILS  ******************** */

/** *********************  START UPDATE FUNDER DETAILS  ******************** */
export function* updateFunderDetails({ payload }: any) {
	try {
		const {
			funderID,
			funderName,
			oldFunderName,
			userPhoneNumber,
			userEmailID,
			userPassword,
			funderAddress,
			userPhoto,
			companyID,
			generalCompanyID,
			investorDetailArr,
			funderUniqueID,
			userID,
			accountDetailsArr,
			databaseName,
			userName,
			userAccessBranchID,
			branchArr,
			infogCompanyID,
		} = payload;
		const infogCmpIDFromAccount = accountDetailsArr[0]?.InfogCmpID || infogCompanyID;
		const key = 'UpdateFunderDetailsKey';
		const jsonData = {
			FunderID: funderID,
			UserName: funderName,
			OldFunderName: oldFunderName,
			UserPhoneNumber: userPhoneNumber,
			UserEmailID: userEmailID,
			UserPassword: userPassword,
			UserAddress: funderAddress,
			UserPhoto: userPhoto,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			InvestorDetails: investorDetailArr,
			UniqueID: funderUniqueID,
			CreatedBy: userID,
			AccountArr: accountDetailsArr,
			DatabaseName: databaseName,
			UserAccessName: userName,
			UserAccessBranchID: userAccessBranchID,
			AreaArr: branchArr,
			InfogCmpID: infogCmpIDFromAccount,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(funderDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateFunderFailure(responseData.data));
		} else {
			yield put(updateFunderSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateFunderFailure(error));
	}
}

/** *********************  RESET UPDATE FUNDER DETAILS RESPONSE ******************** */
export function* resetUpdateFunderDetailsResponse() {
	yield put(updateFunderResponseChanged());
}
/** *********************  ON UPDATE FUNDER DETAILS ******************** */
export function* onUpdateFunderDetails() {
	yield takeLatest(FunderActionTypes.UPDATE_FUNDER_START, updateFunderDetails);
}

/** *********************  ON UPDATE FUNDER RESPONSE RESET ******************** */
export function* onUpdateFunderResponseReset() {
	yield takeLatest(
		FunderActionTypes.UPDATE_FUNDER_RESPONSE_RESET,
		resetUpdateFunderDetailsResponse,
	);
}
/** *********************  END UPDATE FUNDER DETAILS ******************** */

/** *********************  START GET FUNDER DETAILS  ******************** */
export function* getFunderList({ payload }: any) {
	try {
		const {
			companyID,
			userID,
			userRole,
			userAccessBranchID,
			userLevel,
			databaseName,
			limit,
			inputSearch,
		} = payload;
		const key = 'GetFunderListKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			BranchID: userAccessBranchID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			Limit: limit,
			InputSearch: inputSearch,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(funderListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getFunderListFailure(responseData.data));
		} else {
			yield put(getFunderListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getFunderListFailure(error));
	}
}

/** *********************  RESET GET FUNDER LIST RESPONSE  ******************** */
export function* resetGetFunderListResponse() {
	yield put(getFunderListResponseChanged());
}

/** *********************  ON GET FUNDER LIST DETAILS  ******************** */
export function* onGetFunderListDetails() {
	yield takeLatest(FunderActionTypes.GET_FUNDER_LIST_START, getFunderList);
}

/** *********************  ON GET FUNDER LIST RESPONSE RESET  ******************** */
export function* onGetFunderListResponseReset() {
	yield takeLatest(FunderActionTypes.GET_FUNDER_LIST_RESPONSE_RESET, resetGetFunderListResponse);
}
/** *********************  END GET FUNDER LIST ******************** */

/** *********************  START FETCH FUNDER DETAILS  ******************** */
export function* fetchFunderDetails({ payload }: any) {
	try {
		const { companyID, funderID, databaseName } = payload;
		const key = 'FetchFunderDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			FunderID: funderID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(funderDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFunderFailure(responseData.data));
		} else {
			yield put(fetchFunderSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFunderFailure(error));
	}
}
/** *********************  RESET FETCH FUNDER DETAILS RESPONSE  ******************** */
export function* resetFetchFunderDetailsResponse() {
	yield put(fetchFunderResponseChanged());
}

/** *********************  ON FETCH FUNDER DETAILS  ******************** */
export function* onFetchFunderDetails() {
	yield takeLatest(FunderActionTypes.FETCH_FUNDER_START, fetchFunderDetails);
}

/** *********************  ON FETCH FUNDER DETAILS RESPONSE RESET  ******************** */
export function* onFetchFunderDetailsResponseReset() {
	yield takeLatest(
		FunderActionTypes.FETCH_FUNDER_RESPONSE_RESET,
		resetFetchFunderDetailsResponse,
	);
}
/** *********************  END FETCH FUNDER DETAILS ******************** */

/** *********************  START DELETE FUNDER DETAILS  ******************** */
export function* deleteFunder({ payload }: any) {
	try {
		const {
			companyID,
			funderID,
			funderName,
			databaseName,
			userID,
			userAccessBranchID,
			userName,
		} = payload;
		const key = 'DeleteFunderDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			FunderID: funderID,
			FunderName: funderName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserID: userID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(funderDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteFunderFailure(responseData.data));
		} else {
			yield put(deleteFunderSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteFunderFailure(error));
	}
}

/** *********************  RESET DELETE FUNDER DETAILS RESPONSE  ******************** */
export function* resetDeleteFunderDetailsResponse() {
	yield put(deleteFunderResponseChanged());
}

/** *********************  ON DELETE FUNDER DETAILS   ******************** */
export function* onDeleteFunderDetails() {
	yield takeLatest(FunderActionTypes.DELETE_FUNDER_START, deleteFunder);
}

/** *********************  ON DELETE FUNDER DETAILS RESPONSE RESET ******************** */
export function* onDeleteFunderDetailsResponseReset() {
	yield takeLatest(
		FunderActionTypes.DELETE_FUNDER_RESPONSE_RESET,
		resetDeleteFunderDetailsResponse,
	);
}
/** *********************  END DELETE FUNDER DETAILS ******************** */

/** *********************  START UPDATE FUNDER IS PUBLISH STATUS DETAILS  ******************** */
export function* funderIsPublishUpdate({ payload }: any) {
	try {
		const key = 'UpdateFunderPublisKey';
		const jsonData = {
			FunderID: payload.funderID,
			IsPublish: payload.isPublish,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(FunderPublishUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateIsPublishFunderFailure(responseData.data));
		} else {
			yield put(updateIsPublishFunderSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateIsPublishFunderFailure(error));
	}
}
/** *********************  RESET UPDATE FUNDER IS PUBLISH STATUS RESPONSE  ******************** */
export function* resetUpdatePublishFunderResponse() {
	yield put(updateIsPublishFunderResponseChanged());
}

/** *********************  ON UPDATE PUBLISH FUNDER  ******************** */
export function* onUpdatePublishFunder() {
	yield takeLatest(FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_START, funderIsPublishUpdate);
}

/** *********************  ON UPDATE PUBLISH FUNDER RESPONSE RESET  ******************** */
export function* onUpdatePublishFunderResponseReset() {
	yield takeLatest(
		FunderActionTypes.UPDATE_ISPUBLISH_FUNDER_RESPONSE_RESET,
		resetUpdatePublishFunderResponse,
	);
}
/** *********************  START UPDATE FUNDER IS PUBLISH STATUS DETAILS  ******************** */

export function* funderMasterSaga() {
	yield all([
		call(onAddFunderDetails),
		call(onAddFunderDetailsResponseReset),
		call(onUpdateFunderDetails),
		call(onUpdateFunderResponseReset),
		call(onGetFunderListDetails),
		call(onGetFunderListResponseReset),
		call(onFetchFunderDetails),
		call(onFetchFunderDetailsResponseReset),
		call(onDeleteFunderDetails),
		call(onDeleteFunderDetailsResponseReset),
		call(onUpdatePublishFunder),
		call(onUpdatePublishFunderResponseReset),
	]);
}
